const NAV_PROVIDER_KEY = "tc_nav_provider";

export const getSavedNavProvider = () => {
  try {
    return localStorage.getItem(NAV_PROVIDER_KEY);
  } catch (_) {
    return null;
  }
};

export const saveNavProvider = (provider) => {
  try {
    localStorage.setItem(NAV_PROVIDER_KEY, provider);
  } catch (_) {
    // Ignore storage errors (private mode / restricted browsers).
  }
};

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const getProviderOptions = () =>
  isIOS() ? ["apple", "google", "waze"] : ["google", "waze", "apple"];

export const providerLabel = (provider) => {
  if (provider === "apple") return "Apple Maps";
  if (provider === "waze") return "Waze";
  return "Google Maps";
};

export const buildNavigationDestination = (lead) => {
  const lat = Number(lead?.latitude);
  const lng = Number(lead?.longitude);
  const hasCoords = Number.isFinite(lat) && Number.isFinite(lng);
  const address = [
    lead?.address || "",
    lead?.city || "",
    lead?.state || "",
    lead?.zip_code || "",
  ]
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  return {
    lat: hasCoords ? lat : null,
    lng: hasCoords ? lng : null,
    address: address || null,
  };
};

export const buildNavigationUrl = ({ provider, destination }) => {
  const hasCoords =
    Number.isFinite(destination?.lat) && Number.isFinite(destination?.lng);
  const coord = hasCoords ? `${destination.lat},${destination.lng}` : null;
  const query = destination?.address || coord || "";
  const encodedQuery = encodeURIComponent(query);

  switch (provider) {
    case "apple":
      return hasCoords
        ? `https://maps.apple.com/?daddr=${encodeURIComponent(coord)}&dirflg=d`
        : `https://maps.apple.com/?q=${encodedQuery}`;
    case "waze":
      return hasCoords
        ? `https://waze.com/ul?ll=${encodeURIComponent(coord)}&navigate=yes`
        : `https://waze.com/ul?q=${encodedQuery}&navigate=yes`;
    case "google":
    default:
      return `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
  }
};

export const openNavigation = ({ provider, destination }) => {
  const url = buildNavigationUrl({ provider, destination });
  window.location.href = url;
};
